import React, { useEffect } from 'react';
import { useAppSelector } from 'hooks/store';
import { UserDataSelector } from 'store/user';
import { parseJwtToken } from 'utils/jwt';
import { isAuxiliaryCallView } from 'components/CallScribe/auxiliaryView';

interface IProps {
  children: React.ReactNode;
}

const PendoProvider: React.FC<IProps> = ({ children }) => {
  const userData = useAppSelector(UserDataSelector);
  const token = localStorage.getItem('token');

  useEffect(() => {
    if (isAuxiliaryCallView()) return;
    if (userData?.id && token) {
      // Pendo is optional: some clients have blockers that prevent loading `cdn.pendo.io`.
      // Guard and never fail the whole app if Pendo is unavailable.
      try {
        const pendo = (window as any).pendo;
        if (!pendo?.initialize) return;

        const claims = parseJwtToken(token);
        pendo.initialize({
          visitor: {
            id: +userData.id,
            email: userData.email,
            fullName: userData.username,
          },
          account: {
            id: +claims.tenantId,
            tenantName: claims.tenantAlias,
          },
        });
      } catch {
        // ignore: Pendo must never block app bootstrap
      }
    }
  }, [userData?.id, token]);

  return <>{children}</>;
};

export default PendoProvider;
